<!-- 这个按钮方便我们用来切换语言 -->
<template>
  <div class="themeBody" :data-theme="themeMode">


  <div class="areaBox">

    <go-back-button class="Boxtitle">
      <template v-slot:body>
        <div >{{ $t('h.area.regionalSelection') }}</div>
      </template>
    </go-back-button>
    <div style="width: 100%; height: calc(100% - 105px);overflow-y: scroll; ">
    <div class="areaListBox">
      <div v-for="(item, key) in areasData" :key="key">
        <div class="areaListTitle">{{ $t(key) }}</div>
        <div class="areaListTMain">
          <!--   如果浏览器出现兼容性问题 可能要用老版本写法     -->
          <!--<li v-for="(area, areaKey) in item" :key="areaKey">{{ Object.keys(area)[0] }}-{{ area[Object.keys(area)[0]] }}</li>-->
          <div class="areaListItem">
            <el-button @click="changeLanguage(area['language'])" type="info" v-for="(area, areaKey) in item"
                       :key="areaKey" class="areaBtn">
              <div>
                <span class="left-text">{{ $t(Object.keys(area)[0]) }}</span>
                <span class="right-text">{{ $t(area[Object.keys(area)[0]]) }}</span>
                <!--<span class="right-text">{{ area['language'] }}</span>-->
              </div>
            </el-button>
          </div>

        </div>
      </div>
    </div>

    <!--    <div class="full" @click="changeLangEvent()">-->
    <!--      <span class="lan">{{ language }}</span>-->
    <!--      <div>{{ $t('h.language.name') }}</div>-->
    <!--      <div>{{ $t('h.login.login') }}</div>-->
    <!--      <div>{{ getLocalelanguage }}</div>-->
    <!--    </div>-->

    <!--    <el-button @click="qwer">1111</el-button>-->
    </div>
  </div>
  </div>
</template>

<script>
import {setLanguage} from "@/utils/utils";

export default {
  data() {
    return {
      language: localStorage.getItem("locale") || "en",
      areasData: {
        "h.area.recommendedVisits": [
          {"aAndL.zh.Country": "aAndL.zh.Language", 'language': 'zh'},
          {'aAndL.United_States.Country': 'aAndL.United_States.Language', 'language': 'en'}
        ],
        "h.area.NorthAmerica": [
          {'aAndL.Canada.Country': 'aAndL.Canada.Language', 'language': 'en'},
          {'aAndL.United_States.Country': 'aAndL.United_States.Language', 'language': 'en'}
        ],
        "h.area.Europe": [
          {"aAndL.EU_Countries.Country": "aAndL.EU_Countries.Language", 'language': 'en'},
          {"aAndL.ar.Country": "aAndL.ar.Language", 'language': 'ar'},
          {"aAndL.cs.Country": "aAndL.cs.Language", 'language': 'cs'},
          {"aAndL.de.Country": "aAndL.de.Language", 'language': 'de'},
          {"aAndL.en.Country": "aAndL.en.Language", 'language': 'en'},
          {"aAndL.es.Country": "aAndL.es.Language", 'language': 'es'},
          {"aAndL.fr.Country": "aAndL.fr.Language", 'language': 'fr'},
          {"aAndL.he.Country": "aAndL.he.Language", 'language': 'he'},
          {"aAndL.hu.Country": "aAndL.hu.Language", 'language': 'hu'},
          {"aAndL.it.Country": "aAndL.it.Language", 'language': 'it'},
          {"aAndL.nl.Country": "aAndL.nl.Language", "language": "nl"},
          {"aAndL.pt.Country": "aAndL.pt.Language", "language": "pt"},
          {"aAndL.pt_BR.Country": "aAndL.pt_BR.Language", "language": "pt_BR"},
          {"aAndL.ru.Country": "aAndL.ru.Language", "language": "ru"},
          {"aAndL.sv.Country": "aAndL.sv.Language", "language": "sv"},
          {"aAndL.tr.Country": "aAndL.tr.Language", "language": "tr"},
          {"aAndL.uk.Country": "aAndL.uk.Language", "language": "uk"},
        ],
        "h.area.Asia": [
          {"aAndL.zh.Country": "aAndL.zh.Language", 'language': 'zh'},
          {"aAndL.zh_tw.Country": "aAndL.zh_tw.Language", 'language': 'zh_tw'},
          {"aAndL.ja.Country": "aAndL.ja.Language", 'language': 'ja'},
          {"aAndL.ko.Country": "aAndL.ko.Language", 'language': 'ko'},
        ],
        "h.area.Other": [
          {"aAndL.Australia.Country": "aAndL.Australia.Language", 'language': 'en'},
        ],
      }
    }
  },
  mounted() {
    // document.body.style.backgroundColor = "#EEEEEE";
  },
  computed: {
    getLocalelanguage() {
      return this.$store.state.language;
    },
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  methods: {
    changeLanguage(lang) {
      localStorage.getItem(setLanguage(lang))
      this.$i18n.locale = localStorage.getItem('locale');
      console.log("area切换语言成功",this.getLocalelanguage)

      if (this.$store.state.routerUrl !=""){
        this.$router.push({path: this.$store.state.routerUrl})
        this.$store.commit('setRouterUrl',"")
      }else{
        this.$router.go(-1);//切换语言后返回原来的页面 上一页
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';



>>> .areaBox {
  width: 98%;
  max-width: 950px;
  height: 100%;
  max-height: 865px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 15px;

  justify-content: center; /*主轴对齐方式,水平居中*/
  align-items: center; /*垂直对齐方式,居中*/

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @include background_color("background_color");
  @include font_color("text-color");

  .Boxtitle {
    font-size: 22px;
    font-weight: 600;

    border-radius: 15px 15px 0 0; /* 顶部左右圆角，其余角为直角 */
    border-bottom: 1px solid #BEC7CE;
    text-align: center;

    @include background_color("areaBoxtitleBgColor");
    @include font_color("text-color");
  }

  .areaListBox {
    width: 95%;
    height: 650px;


    margin: 0 auto;

    .areaListTitle {
      font-size: 19px;

      text-align: left;
      margin: 15px 0;

    }

    .areaListTMain {

      .areaListItem {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .areaBtn:hover {
        @include background_color("areaBtnHoverBgColor");
      }

      .areaBtn {
        font-size: 15px;
        margin: 5px 0;
        padding: 20px 0;
        width: 49%;
        @include background_color("areaBtnBgColor");
        border: 0px;

        .left-text {
          float: left;
          margin-left: 20px;
          @include font_color("areaLeftTextColor");
        }

        .right-text {
          float: right;
          margin-right: 20px;
          @include font_color("areaRightTextColor");
        }
      }

      /* 媒体查询：屏幕宽度小于768px */
      @media screen and (max-width: 768px) {
        .areaBtn {
          width: 100%; /* 一行显示一个地区 */
        }
      }

    }

  }

}


</style>



// WEBPACK FOOTER //
// src/views/area/area.vue